var Func = (() => {
  function add0(m) {
    return m < 10 ? '0' + m : m
  }
  var formFormat = (format) => {
    if(String(format).length > 15){
      return format
    }
    if(!format){
      var d = new Date();
    }else {
      var d = new Date(format * 1000);    //根据时间戳生成的时间对象
    }

    var date = (d.getFullYear()) + "-" +
      (d.getMonth() + 1) + "-" +
      (d.getDate()) + " " +
      (d.getHours()) + ":" +
      (d.getMinutes()) + ":" +
      (d.getSeconds());
    return date
  }
  var formFormatTime = (format) => {
    var times = ''
    var hours = ''
    if(String(format).length > 15){
      var d = new Date(format);    //根据时间戳生成的时间对象
      times = (d.getMonth() + 1) + "-" + (d.getDate())
      hours = (d.getHours()) + ":" + (d.getMinutes().toString().length === 2 ? d.getMinutes():'0'+ d.getMinutes())
      return {
        times: times,
        hours: hours
      }
    }
    var d = new Date(format * 1000);    //根据时间戳生成的时间对象
    times = (d.getMonth() + 1) + "-" + (d.getDate())
    hours = (d.getHours()) + ":" + (d.getMinutes().toString().length === 2 ? d.getMinutes():'0'+ d.getMinutes())
    return {
      times: times,
      hours: hours
    }
  }
  var formatTimeSecond = (shijianchuo) => {
    //shijianchuo是整数，否则要parseInt转换
    if (shijianchuo.toString().length==10) {
      shijianchuo = shijianchuo*1000
    }
    var time = new Date(shijianchuo-0);
    var y = time.getFullYear();
    var m = time.getMonth() + 1;
    var d = time.getDate();
    var h = time.getHours();
    var mm = time.getMinutes();
    var s = time.getSeconds();

    return /*y + '-' + add0(m) + '-' + add0(d) + ' ' + */add0(h) + ':' + add0(mm) + ':' + add0(s);
  }

  var getCode = () => {
    //获取当前时间
    var date = new Date();
    var seperator1 = "-";
    var year = date.getFullYear();
    var month = date.getMonth() + 1;
    var strDate = date.getDate();
    if (month >= 1 && month <= 9) {
      month = "0" + month;
    }
    if (strDate >= 0 && strDate <= 9) {
      strDate = "0" + strDate;
    }
    return new Array(year, month, strDate).join('')
  }
  /**
   * randomWord 产生任意长度随机字母数字组合
   * randomFlag-是否任意长度 min-任意长度最小位[固定位数] max-任意长度最大位
   * 用法  randomWord(false,6);规定位数 flash
   *      randomWord(true,3，6);长度不定，true
   * arr变量可以把其他字符加入，如以后需要小写字母，直接加入即可
   */
  var randomWord = function(randomFlag, min, max) {

    let str = "",
      range = min,
      arr = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z'];
    // 随机产生
    if (randomFlag) {
      range = Math.round(Math.random() * (max - min)) + min;
    }
    for (let i = 0; i < range; i++) {
      let pos = Math.round(Math.random() * (arr.length - 1));
      str += arr[pos];
    }
    return str;
  }

  return {
    formFormat: formFormat,
    formFormatTime: formFormatTime,
    formatTimeSecond: formatTimeSecond,
    randomWord: randomWord,
    getCode: getCode
  }

})();
module.exports = Func;





// WEBPACK FOOTER //
// ./src/api/func.js